/* import __COLOCATED_TEMPLATE__ from './email-follow-up.hbs'; */
/* RESPONSIBLE TEAM: team-ai-agent */

import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import type { FinSetupBehaviorSaveParams } from 'embercom/lib/operator/fin/types';
import { inject as service } from '@ember/service';
import type IntlService from 'ember-intl/services/intl';
import type Profile from 'embercom/models/ai-agent/profile';

type EmailFollowUpOption = 'follow_up' | 'no_follow_up';

interface Args {
  accordion: $TSFixMe;
  ruleset: $TSFixMe;
  partialSave: (params: FinSetupBehaviorSaveParams) => void;
}

interface Signature {
  Args: Args;
}

export default class EmailFollowUp extends Component<Signature> {
  @service declare intl: IntlService;
  @tracked selectedOption: EmailFollowUpOption =
    (this.behavior.emailFollowUpType as EmailFollowUpOption) || 'follow_up';

  get ruleset() {
    return this.args.ruleset;
  }

  get behavior(): Profile {
    return this.ruleset.rulesetLinks.firstObject.object;
  }

  get options() {
    return [
      {
        value: 'follow_up' as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-follow-up',
        subtitleTranslationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-follow-up-subtitle',
      },
      {
        value: 'no_follow_up' as const,
        translationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-no-follow-up',
        subtitleTranslationKey:
          'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.option-no-follow-up-subtitle',
      },
    ];
  }

  get selectedLabel() {
    switch (this.selectedOption) {
      case 'follow_up':
        return this.intl.t(
          'operator.fin.setup.setup-and-go-live.email-follow-up.summary-follow-up',
        );
      case 'no_follow_up':
        return this.intl.t(
          'operator.fin.setup.setup-and-go-live.email-follow-up.summary-no-follow-up',
        );
    }
  }

  get shouldShowPreview() {
    return this.selectedOption !== 'no_follow_up';
  }

  get previewText() {
    return this.intl.t(
      'operator.workflows.visual-builder.pass-to-fin.settings.email-follow-up.preview-text',
    );
  }

  @action
  setSelectedOption(option: EmailFollowUpOption) {
    this.selectedOption = option;
  }

  @action
  async updateEmailFollowUpConfig() {
    this.args.partialSave({
      email_follow_up_type: this.selectedOption,
    });
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Operator::Fin::Setup::Sections::EmailFollowUp': typeof EmailFollowUp;
    'operator/fin/setup/sections/email-follow-up': typeof EmailFollowUp;
  }
}
